import Modal from '../../..';
import Form from '../../../../Form';
import useStore from '../../../../Hooks/useStore';


const ModalLogisticOriginCreate = () => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    modal: { closeSingleModal },
  } = setters;
  const isOpen = getModal('single.createLogisticOrigin');
  const onClose = () => {
    closeSingleModal('createLogisticOrigin');
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle="Nova logística origem"
      height={'auto'}
      width={'60vw'}
    >
      <Form.Export.Logistic.Origin.Create />
    </Modal>
  );
};

export default ModalLogisticOriginCreate;
